import type { JSX } from "react";
import { color } from "@styles";
import { Anchor } from "components/atoms/Anchor";
import { P1 } from "components/atoms/Paragraph";
import { VideoPlayer } from "components/atoms/VideoPlayer";
import { YULIFE_DATA } from "utils/_constants";

type Data = {
  tabs: Tab[];
};
export interface Tab {
  title: string;
  heading?: string | JSX.Element;
  content?: string | JSX.Element;
  image?: string | JSX.Element;
  alt?: string;
  url?: string;
  callToAction?: string;
  footnote?: string;
}

export const data: Data = {
  tabs: [
    {
      title: "Community",
      heading: "An app that people love (and actually use)",
      content:
        "Give your members access to a co-branded version of YuLife’s award-winning app. Each day, your members unlock rewards for doing everyday, healthy activities from walking, to cycling to meditating. Create a community of wellbeing with social features like leaderboards. As far as engagement goes - an average of 2 in 3 employees download the app, and 1 in 2 interact with it weekly!¹",
      image: (
        <img
          src="/static/pages/individuals/yumoji-us-leaderboard-screen.png"
          alt="YuMoji avatars on the podium of the leaderboard showing first, second and third place on the leaderboard screen."
        />
      ),
      url: "/us/features/employee-app",
      footnote: `¹${YULIFE_DATA}`,
    },
    {
      title: "Rewards",
      heading: "Reward your people & protect the planet",
      content: (
        <P1 pt="0">
          Members earn{" "}
          <Anchor
            href="/us/blog/what-is-yucoin-and-how-does-it-work/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: `${color.yulifePink.P100}` }}
          >
            YuCoin
          </Anchor>{" "}
          for completing wellbeing activities to unlock real-world rewards – from retail gift cards,
          to charitable donations. Since using the YuLife app, nearly 90% of YuLifers report feeling
          happier and more productive!²
        </P1>
      ),
      image: (
        <VideoPlayer webm="/static/pages/insurance-carriers/yulife-us-rewards-screen.mp4" center />
      ),
      alt: "A GIF of the rewards section of the YuLife US app showing the Starbucks, Earthly and ShareTheMeal.",
      url: "/us/features/rewards",
      footnote: "YuLife user survey, 2022",
    },
    {
      title: "Insurance",
      heading: "A “one-stop shop” for insurance",
      content:
        "Stay connected to and top of mind for members. From your key policy documents to claims forms and support lines, your members can easily access existing details and browse new cover – all in one app they regularly visit.",
      image: (
        <img
          src="/static/pages/insurance-carriers/yulife-us-yuscreen.png"
          alt="An animated illustration of the kind of avatar available to users of the YuLife app. The male avatar, with khaki trousers and a beige t-shirt stands next to three bars, showing the YuCoin power for insurance and protection packages available."
        />
      ),
      url: "/us/features/wellbeing-hub",
    },
    {
      title: "Insights",
      heading: "Data that delivers",
      content:
        "We understand your need to capture and track employee wellbeing data. Our HR portal provides detailed insight into wellbeing patterns that point to behavioral trends, and reports that reveal real business ROI.",
      image: (
        <img
          src="/static/pages/insurance-carriers/yulife-us-employer-hr-portal-data-dashboard.png"
          alt="The YuLife employer portal dashboard, showing data available to managers. You can see the steps taken by employees, challenges and meditation minutes, and YuCoin earned."
        />
      ),
      url: "/us/features/hr-insights",
    },
  ],
};
